import React from "react";

export default function PreloaderMin(props){
    return (
        <div className={props.className}>
            Preloader Min
        </div>
    )
}